<div class="ab-cards">
  <div class="ab-card ab-card--no-border">
    <h1 class="ab-card__data">
      {{ requestCount | numberToHuman }}
      <ab-trend
        class="ab-card__trend"
        [countList]="requestCountList"
        [dur]="dur"
        [statType]="'requests'"
        [neutralStyle]="true"
      ></ab-trend>
    </h1>
    <div class="ab-card__label">
      Requests
      <ab-response-codes-bar
        class="response-codes-bar-container response-codes-bar-container--absolute-bottom"
        [data]="requestCodesBar"
      >
      </ab-response-codes-bar>
    </div>
  </div>
  <div class="ab-card ab-card--no-border">
    <h1 class="ab-card__data">
      {{ errorRate | rateFormat }}
      <span class="text-unit">%</span>
      <ab-trend
        class="ab-card__trend"
        [countList]="errorRateCountList"
        [dur]="dur"
        [statType]="'error rate'"
        [performanceTrend]="true"
      ></ab-trend>
    </h1>
    <div class="ab-card__label">
      Error rate
      <div
        class="ab-inline-tooltip"
        ngbTooltip="Error occurrences per request"
        container="body"
      >
        <span
          class="glyphicon glyphicon-question-circle glyphicon--blue"
        ></span>
      </div>
    </div>
  </div>
</div>
